import { render, staticRenderFns } from "./BaseDetail.vue?vue&type=template&id=440486ba&scoped=true"
import script from "./BaseDetail.vue?vue&type=script&lang=js"
export * from "./BaseDetail.vue?vue&type=script&lang=js"
import style0 from "./BaseDetail.vue?vue&type=style&index=0&id=440486ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440486ba",
  null
  
)

export default component.exports